import React from 'react';
import IconTrash from '@creditflowresearch/uilib/Icon/IconTrash';
import { usePositionsContext } from '@/creditflowresearch/application/PortfolioMonitor/PositionsContext';

import styles from './styles.module.scss';
import IconButton from '@creditflowresearch/uilib/IconButton';

const BulkDeletePositions = () => {
  const {
    selection,
    confirmDeletePositionsModal: {
      showCanceledModal,
    },
  } = usePositionsContext();

  if (selection.collection.length > 0) {
    return (
      <IconButton
        icon={ <IconTrash /> }
        dataTest="positionsBulkDeleteButton"
        color="primary"
        onClick={ showCanceledModal }
        className={ styles.button }
        ariaLabel="Delete selected positions"
      />
    );
  }

  return null;
};

export default BulkDeletePositions;
